export default "__VITE_ASSET__BEHnpQu7__"